exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_editPanel_2Q-uoGlKgEawXPF0Ug9618 {\n  box-sizing: border-box;\n  width: 600px;\n}\n\n.IA_splashScreenInfo_1BvUI9Ze4QGaCOYcLiJCTK {\n  padding: 10px;\n  background-color: #f8f8f8;\n  font-size: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_editPanel": "IA_editPanel_2Q-uoGlKgEawXPF0Ug9618",
	"IA_splashScreenInfo": "IA_splashScreenInfo_1BvUI9Ze4QGaCOYcLiJCTK"
};